import React from 'react';
import { useDocumentSequence } from '../../hooks/document/useDocumentSequence';
import ViewModal from '../../components/Modals/ViewModal';
import InfoField from '../../components/Shared/InfoField';
import { formatFriendlyDateTime } from '../../utils/dateFormatters';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

const DocumentSequenceViewPopup: React.FC<Props> = ({ isOpen, onClose }) => {
  const { detail } = useDocumentSequence();

  return (
    <ViewModal
      popupOpen={isOpen}
      setPopupOpen={onClose}
      title="Número de Control Interno"
      maxWidth="max-w-3xl"
    >
      {/* Encabezado */}
      <div className="mb-6 flex flex-col items-start gap-1">
        <h2 className="text-gray-800 text-2xl font-bold dark:text-white">
          {detail?.prefix} {/* Ej: DTE */}
        </h2>
        <p className="text-gray-600 dark:text-gray-300 text-sm">
          Sucursal: {detail?.branchName}
        </p>
      </div>

      {/* Datos */}
      <h4 className="text-gray-700 mb-2 text-base font-semibold dark:text-white">
        Datos Generales
      </h4>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <InfoField label="Tipo de Documento" value={detail?.documentTypeName} />
        <InfoField label="Prefijo" value={detail?.prefix} />
        <InfoField
          label="Correlativo Actual"
          value={detail?.currentNumber?.toString()}
        />
        <InfoField
          label="Creado en"
          value={
            detail?.createdAt ? formatFriendlyDateTime(detail.createdAt) : ''
          }
        />
      </div>

      {/* Botón */}
      <button
        onClick={onClose}
        className="mt-8 w-full rounded-md bg-primary px-4 py-2 text-white hover:bg-opacity-90"
      >
        Cerrar
      </button>
    </ViewModal>
  );
};

export default DocumentSequenceViewPopup;
